"use client";

import NoSsr from "@mui/material/NoSsr";
import Skeleton from "@mui/material/Skeleton";
import React from "react";
import { twMerge } from "tailwind-merge";

import styles from "./Skeletons.module.scss";
import { ChartSkeletonProps, SkeletonsProps } from "./SkeletonsProps";

export const Skeletons = React.memo<SkeletonsProps>(
  ({
    className,
    colClassName,
    rows = 2,
    columns = 1,
    maxHeight = undefined,
    minColumnWidth = "200px",
    rowHeight = "0.8rem",
  }) => (
    <NoSsr>
      <div
        className={twMerge(
          "flex h-full w-full flex-wrap gap-4 overflow-hidden",
          className
        )}
        style={
          {
            maxHeight,
          } as React.CSSProperties
        }
      >
        {Array.from({ length: columns }, (_, colIndex) => (
          <div
            key={colIndex}
            className={twMerge("flex flex-1 flex-col gap-3", colClassName)}
            style={{
              minWidth: minColumnWidth,
            }}
          >
            {Array.from({ length: rows }, (_, rowIndex) => {
              return (
                <Skeleton
                  animation="wave"
                  key={rowIndex}
                  variant="rounded"
                  height={rowHeight}
                  data-testid="skeleton"
                  width={rowIndex % 2 === 0 ? "80%" : "60%"}
                />
              );
            })}
          </div>
        ))}
      </div>
    </NoSsr>
  )
);
Skeletons.displayName = "Skeletons";

export const ChartSkeletons = React.memo<ChartSkeletonProps>(
  ({ className, backgroundColor }) => {
    const bars = Array.from({ length: 50 }, () =>
      Math.floor(Math.random() * (200 - 20 + 1) + 20)
    );

    return (
      <NoSsr>
        <div className={twMerge(styles["highway-slider"], className)} data-testid="chart-skeletons">
          <div
            className={styles["highway-barrier"]}
            style={
              {
                "--background-color": backgroundColor,
              } as React.CSSProperties
            }
          >
            <ul className={styles["highway-lane"]}>
              {bars.map((height, index) => (
                <span className={styles["highway-car"]} key={index}>
                  <Skeleton
                    variant="rectangular"
                    height={height}
                    width="1.5rem"
                  />
                </span>
              ))}
              {bars.map((height, index) => (
                <span className={styles["highway-car"]} key={index}>
                  <Skeleton
                    variant="rectangular"
                    height={height}
                    width="1.5rem"
                  />
                </span>
              ))}
            </ul>
          </div>
        </div>
      </NoSsr>
    );
  }
);
ChartSkeletons.displayName = "ChartSkeletons";
